module.exports = __webpack_public_path__ + "img/logo.f14b2b72.png";